import { useState } from "react";
import { Loader2 } from "lucide-react";
import { useI18n } from "../i18n";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { AuthCard } from "../components/auth/AuthCard";

const inputCls = "h-12 w-full rounded-xl border border-slate-200 px-4 text-base text-ink outline-none focus:border-navy focus:ring-4 focus:ring-brand/20";

export default function ChangePassword() {
  const { t } = useI18n();
  const { user, logout } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 10) return setError(t("x.pw.short"));
    if (f.next !== f.confirm) return setError(t("auth.pwMismatch"));
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      window.location.assign("/");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(d === "wrong_current_password" ? t("x.pw.wrong") : d === "same_password" ? t("x.pw.same") : t("common.error"));
      setBusy(false);
    }
  };

  return (
    <AuthCard title={t("x.pw.title")} subtitle={`${user.email} · ${t("x.pw.sub")}`} testId="change-password-card">
      <form onSubmit={submit} className="mt-6 space-y-4">
        <input type="password" autoComplete="current-password" required value={f.current} onChange={set("current")} placeholder={t("x.pw.current")} className={inputCls} data-testid="change-password-current" />
        <input type="password" autoComplete="new-password" required value={f.next} onChange={set("next")} placeholder={t("auth.newPassword")} className={inputCls} data-testid="change-password-new" />
        <input type="password" autoComplete="new-password" required value={f.confirm} onChange={set("confirm")} placeholder={t("auth.confirmPassword")} className={inputCls} data-testid="change-password-confirm" />
        {error && <p role="alert" className="rounded-xl bg-rose-50 px-4 py-3 text-sm text-rose-700" data-testid="change-password-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="change-password-submit" className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-brand text-base font-semibold text-navy hover:bg-[#8BC21F] disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}{t("auth.savePassword")}
        </button>
      </form>
      <button type="button" onClick={logout} className="mt-4 h-11 w-full text-sm font-medium text-slate-500" data-testid="change-password-logout">{t("common.logout")}</button>
    </AuthCard>
  );
}
